/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

// tslint:disable:max-line-length

import { svg } from '@sick-davinci/ce-decorators';
export const SICK_LOGO = svg`<svg
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   class="sick-svg-logo"
   viewBox="0 0 751.02002 239.871"
>
<g id="g3823"><path
     id="path3766"
     d="m 1.025,178.807 c 0,38.797 34.104,55.507 65.054,55.507 h 72.743 c 38.876,0 69.38,-36.108 69.38,-72.051 0,-38.999 -30.863,-69.818 -69.573,-70.843 H 68.093 C 49.15,88.311 50.28,61.012 68.093,58.455 H 200.556 C 200.556,28.074 177.698,4.13 145.714,4.13 H 68.093 c -39.918,0 -67.462,34.471 -67.462,71.289 0,38.281 29.803,70.431 67.462,70.431 h 70.729 c 17.91,3.521 20.152,28.936 0,32.956 H 1.025 Z"
     style="fill:#097cbc" /><rect
     id="rect3768"
     height="230.21001"
     width="54.360001"
     y="4.1129999"
     x="228.625"
     style="fill:#097cbc" /><path
     id="path3770"
     d="m 530.234,176.11 c -19.981,37.851 -59.593,63.618 -105.029,63.618 -65.605,0 -118.783,-53.704 -118.783,-119.94 0,-66.245 53.178,-119.931 118.783,-119.931 44.998,0 84.146,25.249 104.311,62.497 l -48.68,26.265 C 469.95,68.546 448.904,55.181 425.206,55.181 c -34.559,0 -63.468,28.428 -63.468,64.607 0,36.179 28.91,64.616 63.468,64.616 24.189,0 45.734,-13.925 56.418,-34.69 z"
     style="fill:#097cbc" /><polygon
     id="polygon3772"
     points="605.71,234.323 605.71,145.125 625.029,145.125 682.885,234.314 750.513,234.314 673.776,120.672 751.651,4.113 684.041,4.113 626.887,96.439 605.71,96.439 605.71,4.113 550.745,4.113 550.745,234.323 "
     style="fill:#097cbc" /></g>
</svg>`;
